(function () {
  // Find the real source block (inside the form) and the footer slot
  const source = document.getElementById('cart-contact-required');
  const slot = document.getElementById('cart-contact-slot');
  if (!source || !slot) return;

  // Clone visible copy for the footer (don’t submit these)
  const visible = source.cloneNode(true);
  visible.id = 'cart-contact-visible';
  // Tweak IDs to avoid duplicates
  const emailV = visible.querySelector('#cart-contact-email');
  const phoneV = visible.querySelector('#cart-contact-phone');
  if (emailV) { emailV.id = 'cart-contact-email-visible'; emailV.removeAttribute('name'); }
  if (phoneV) { phoneV.id = 'cart-contact-phone-visible'; phoneV.removeAttribute('name'); }
  const errEmailV = visible.querySelector('[data-error-for="cart-contact-email"]');
  const errPhoneV = visible.querySelector('[data-error-for="cart-contact-phone"]');
  if (errEmailV) errEmailV.setAttribute('data-error-for', 'cart-contact-email-visible');
  if (errPhoneV) errPhoneV.setAttribute('data-error-for', 'cart-contact-phone-visible');

    // Privacy checkbox
  const agreeV = visible.querySelector('#cart-privacy-agree');
  if (agreeV) {
    agreeV.id = 'cart-privacy-agree-visible';
    agreeV.removeAttribute('name');
    const errAgreeV = visible.querySelector('[data-error-for="cart-privacy-agree"]');
    if (errAgreeV) errAgreeV.setAttribute('data-error-for', 'cart-privacy-agree-visible');
  }

  // Insert visible copy above the Checkout button
  slot.appendChild(visible);

  // Hide the source block (we keep it for submission)
  source.classList.add('cart-contact-required--hidden');

  // ---------- Privacy Policy modal wiring ----------
  const modal = document.getElementById('privacy-policy-modal');
  if (modal) {
    const openers = document.querySelectorAll('[data-privacy-open]');
    const closers = modal.querySelectorAll('[data-privacy-close]');
    const openModal = (e) => {
      e.preventDefault();
      modal.classList.add('is-active');
      modal.setAttribute('aria-hidden', 'false');
    };
    const closeModal = (e) => {
      if (e) e.preventDefault();
      modal.classList.remove('is-active');
      modal.setAttribute('aria-hidden', 'true');
    };
    openers.forEach((btn) => btn.addEventListener('click', openModal));
    closers.forEach((btn) => btn.addEventListener('click', closeModal));
    modal.addEventListener('click', (e) => {
      if (e.target === modal) closeModal(e);
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeModal(e);
    });
  }

  // Keep values in sync (visible -> hidden)
  const emailHidden = document.getElementById('cart-contact-email');
  const phoneHidden = document.getElementById('cart-contact-phone');
  const sync = (from, to) => { if (from && to) to.value = from.value; };

  if (emailV && emailHidden) {
    emailV.addEventListener('input', () => sync(emailV, emailHidden));
    // Prefill visible from hidden (if user had values)
    emailV.value = emailHidden.value || '';
  }
  if (phoneV && phoneHidden) {
    phoneV.addEventListener('input', () => sync(phoneV, phoneHidden));
    phoneV.value = phoneHidden.value || '';
  }
})();
